@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"
    ></ws-busy-indicator>
}
<ws-modal-wrapper
    headerLabel="Appeal Recommendation"
    [hideSave]="true"
    [hideCancel]="true"
    [hideFooter]="true"
    acceptLabel=""
    (cancel)="close()"
    [loading]="!initialized"
    [useAceStyles]="false">
    <div class="d-flex flex-column">
        @if (initialized && appealRecommendationInfo) {
            <div class="d-flex"
                 wsFileDrop
                 [dropDisabled]="!editing || selectedView !== PanelView.Attachments"
                 (filesDropped)="onFilesDropped($event)">
                <div class="d-flex flex-column pb-4 pe-5">
                    <div class="view-toggle d-flex">
                        <button class="align-items-center justify-content-center"
                                [class.selected]="selectedView === PanelView.Options"
                                (click)="changeTab(PanelView.Options)">
                            OPTIONS
                        </button>
                        <button class="align-items-center justify-content-center"
                                [class.selected]="selectedView === PanelView.Attachments"
                                (click)="changeTab(PanelView.Attachments)">
                            ATTACHMENTS
                        </button>
                    </div>
                    <div class="tab-panel" [class.active]="selectedView === PanelView.Options" [ngStyle]="panelSize"
                         #optionsPanel1>
                        <div class="d-flex justify-content-between">
                            <label class="header-title">Template</label>
                                <div class="float-end header-button-container ws-flex-container-horizontal"
                                     [style.visibility]="editing ? 'visible' : 'hidden'">
                                    <div class="action-button-wrapper"
                                         helpTooltip
                                         [helpContentId]="editHelpContentId"
                                         position="bottom">
                                        <button type="button"
                                                class="ace-btn has-icon btn-primary"
                                                [disabled]="!canEditDelete"
                                                (click)="editTemplate(false)">
                                            <i class="fa fa-save fa-align"></i>
                                        </button>
                                    </div>
                                    <div class="action-button-wrapper"
                                         helpTooltip
                                         [helpContentId]="copyHelpContentId"
                                         position="bottom">
                                        <button type="button"
                                                class="ace-btn has-icon btn-primary"
                                                [disabled]="!editing"
                                                (click)="editTemplate(true)">
                                            <i class="fa fa-copy fa-align"></i>
                                        </button>
                                    </div>
                                    <div class="action-button-wrapper"
                                         helpTooltip
                                         [helpContentId]="deleteHelpContentId"
                                         position="bottom">
                                        <button type="button"
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                [disabled]="!canEditDelete"
                                                (click)="deleteTemplate()">
                                            <i class="fa fa-trash fa-align"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <select id="selectedTemplate"
                                        class="form-select form-select-sm"
                                        [(ngModel)]="selectedTemplate"
                                        (change)="onTemplateChanged()">
                                    @for (spec of templates; track spec) {
                                        <option [ngValue]="spec">{{ spec.name }}</option>
                                    }
                                </select>
                                <span class="visibility-tooltip" [popover]="visibilityTooltip" placement="bottom"
                                      triggers="mouseenter:mouseleave">
                                    <i class="fa fa-info-circle small"></i>
                                </span>
                            </div>
                            <table>
                            <tr>
                                <td class="pe-2">
                                    <label>
                                        <input class="mb-0 lh-2-5"
                                               type="checkbox"
                                               id="includeSiteComment"
                                               [(ngModel)]="savedSettings.includeSiteComment"
                                               [disabled]="!editing"
                                               helpTooltip
                                               [helpContentId]="getCheckboxHelpContentId()">
                                        Include Site Comment
                                    </label>
                                </td>
                                <td class="ps-2">
                                    <div dropdown
                                         container="body"
                                         placement="bottom right"
                                         [isDisabled]="!editing"
                                         helpTooltip
                                         [helpContentId]="getCheckboxHelpContentId()">
                                        <button id="editSiteCommentsButton" dropdownToggle type="button"
                                                class="ace-btn btn-sm btn-secondary dropdown-toggle"
                                                aria-controls="dropdown-basic">
                                            Site Comment
                                            <span class="caret"></span>
                                        </button>
                                        <ul id="editSiteCommentsDropdown" *dropdownMenu
                                            class="dropdown-menu dropdown-menu-right" role="menu"
                                            aria-labelledby="button-basic">
                                            @for (site of sites; track site) {
                                                <li role="menuitem">
                                                    <a class="pointer"
                                                       (click)="commentSiteChanged(site.siteId)">{{ site.siteName }}</a>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="pe-2">
                                    <label class="text-nowrap">
                                        <input type="checkbox"
                                               id="includePriorYear"
                                               [(ngModel)]="savedSettings.showPriorYear"
                                               [disabled]="!editing"
                                               helpTooltip
                                               [helpContentId]="getCheckboxHelpContentId()">
                                        Show Prior Year
                                    </label>
                                </td>
                                <td class="ps-2">
                                    <label class="text-nowrap">
                                        <input id="showYearBuilt"
                                               [(ngModel)]="savedSettings.showYearBuilt"
                                               type="checkbox"
                                               [disabled]="!editing"
                                               helpTooltip
                                               [helpContentId]="getCheckboxHelpContentId()" />
                                        Show Year Built
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td class="pe-2">
                                    <label class="text-nowrap">
                                        <input id="showAcquisitionInfo"
                                               [(ngModel)]="savedSettings.showAcquisitionInfo"
                                               type="checkbox"
                                               [disabled]="!editing"
                                               helpTooltip
                                               [helpContentId]="getCheckboxHelpContentId()" />
                                        Show Acquisition Info
                                    </label>
                                </td>
                                <td class="ps-2">
                                    <label class="text-nowrap">
                                        <input id="showAppealDeadlines"
                                               [(ngModel)]="savedSettings.showAppealDeadlines"
                                               type="checkbox"
                                               [disabled]="!editing"
                                               helpTooltip
                                               [helpContentId]="getCheckboxHelpContentId()" />
                                        Show Appeal Deadlines
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td class="pe-2">
                                    <label class="text-nowrap">
                                        <input id="showEmptyColumns"
                                               [(ngModel)]="savedSettings.showEmptyColumns"
                                               type="checkbox"
                                               [disabled]="!editing"
                                               helpTooltip
                                               [helpContentId]="getCheckboxHelpContentId()" />
                                        Show Empty Columns
                                    </label>
                                </td>
                                <td class="ps-2"></td>
                            </tr>
                        </table>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Assessments</label>
                            <ws-select
                                name="showAssessments"
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showAssessmentOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showAssessments"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Metrics</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showMetricOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showMetrics"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Initial Value</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showInitialValueOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showInitialValue"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Target Value</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showTargetValueOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showTargetValue"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Latest Value</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showLatestValueOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showLatestValue"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Taxable Values</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showTaxableValuesOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showTaxableValues"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Tax Details</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showTaxDetailsOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showTaxDetails"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Savings</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showSavingOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showSavings"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Attach Chart</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="attachChartOptions"
                                labelProperty="name"
                                valueProperty="value"
                                disabledProperty="isDisabled"
                                titleProperty="title"
                                [(ngModel)]="savedSettings.attachChart"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Embed Chart</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="embedChartOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.embedInEmail"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                        <div class="d-flex justify-content-between mt-3">
                            <label class="text-nowrap">Show Exemptions</label>
                            <ws-select
                                helpTooltip
                                [helpContentId]="getCheckboxHelpContentId()"
                                [options]="showExemptionsOptions"
                                labelProperty="name"
                                valueProperty="value"
                                [(ngModel)]="savedSettings.showExemptions"
                                [disabled]="!editing">
                            </ws-select>
                        </div>
                    </div>
                    <div class="tab-panel" [class.active]="selectedView === PanelView.Attachments" [ngStyle]="panelSize"
                         #optionsPanel2>
                        <div class="d-flex flex-column">
                            <arcc-attachments [sites]="sites" [editMode]="editing"></arcc-attachments>
                        </div>
                    </div>
                </div>
                <div class="vr"></div>
                <div class="d-flex flex-column flex-grow-1 ps-4 right-panel">
                    <attachment-selections [editMode]="editing"></attachment-selections>
                    <div class="line">
                        <div class="email-recipient d-flex align-items-center">
                            <div style="width:25px;">To:</div>
                            @if (!editing) {
                                <div>
                                    @for (toRecipient of appealRecommendationInfo.toRecipients; track toRecipient.value; let last = $last) {
                                        {{ toRecipient.name }}@if (!last) {, }
                                    }
                                </div>
                            }
                            @if (editing) {
                                <div style="width: 97%">
                                    <multi-user-picker [(selectedUsers)]="this.appealRecommendationInfo.toRecipients"
                                                       [taskIds]="taskIds"
                                                       [isTo]="true">
                                    </multi-user-picker>
                                </div>
                            }
                        </div>
                        <span (click)="refresh()" class="clickable" [style.visibility]="editing ? 'hidden' : 'visible'">
                            <i class="fa fa-refresh"></i>
                        </span>
                    </div>
                    <div class="line">
                        <div class="email-recipient d-flex align-items-center">
                            <div style="width:25px;">CC:</div>
                            @if (!editing) {
                                <div>
                                    @for (ccRecipient of appealRecommendationInfo.ccRecipients; track ccRecipient.value; let last = $last) {
                                        {{ ccRecipient.name }}@if (!last) {, }
                                    }
                                </div>
                            }
                            @if (editing) {
                                <div style="width: 97%">
                                    <multi-user-picker [(selectedUsers)]="this.appealRecommendationInfo.ccRecipients"
                                                       [taskIds]="taskIds">
                                    </multi-user-picker>
                                </div>
                            }
                        </div>
                        <span class="clickable" style="visibility: hidden;">
                            <i class="fa fa-refresh"></i>
                        </span>
                    </div>
                    <div class="line">
                        @if (!editing) {
                            <div class="data-text-field w-100 me-3 text-ellipsis">
                                {{ appealRecommendationInfo.emailSubject }}
                            </div>
                        }
                        @if (editing) {
                            <input type="text" id="template-subject" class="form-control d-inline-block"
                                   style="width: 90%;"
                                   [(ngModel)]="appealRecommendationInfo.emailSubjectTemplate"
                                   maxlength="500"
                                   placeholder="Subject ...">
                        }
                        @if (editing) {
                            <div class="btn-group buttongroup-last" style="margin-left: -5px;" dropdown>
                                <button dropdownToggle type="button"
                                        class="ace-btn btn-sm btn-secondary dropdown-toggle"
                                        style="width: initial;">
                                    Insert Field
                                    <span class="caret"></span>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                    @for (field of emailTemplateSubjectFields; track field) {
                                        <li role="menuitem">
                                            <a class="dropdown-item clickable"
                                               (click)="insertFieldInSubject(field)">{{ field.name }}</a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                        @if (!editing) {
                            <span (click)="edit()" class="clickable">
                                <i class="fa fa-pencil"></i>
                            </span>
                        }
                    </div>
                    <div class="editor d-flex flex-column flex-grow-1 w-100 overflow-hidden">
                        @if (!editing) {
                            <div
                                class="data-text-field email-preview-display d-flex flex-column flex-grow-1 w-100"
                                [innerHTML]="emailBody">
                            </div>
                        }
                        @if (editing) {
                            <div class="d-flex w-100 h-100">
                                <quill-editor
                                    class="d-flex flex-column w-100"
                                    [(ngModel)]="appealRecommendationInfo.emailBodyTemplate"
                                    (onContentChanged)="contentChange($event)"
                                    [placeholder]="'Email Body ...'"
                                    (onEditorCreated)="addBindingCreated($event)">
                                    <div quill-editor-toolbar>
                                        <!-- Basic buttons -->
                                        <span class="ql-formats">
                                            <button class="ql-bold" [title]="'Bold'"></button>
                                            <button class="ql-italic" [title]="'Italic'"></button>
                                            <button class="ql-underline" [title]="'Underline'"></button>
                                            <button class="ql-strike" [title]="'Strike'"></button>
                                        </span>
                                        <!-- Size -->
                                        <span class="ql-formats">
                                            <select class="ql-size" [title]="'Size'">
                                                <option value="small"></option>
                                                <option selected></option>
                                                <option value="large"></option>
                                                <option value="huge"></option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <select class="ql-align" [title]="'Aligment'">
                                                <option selected></option>
                                                <option value="center"></option>
                                                <option value="right"></option>
                                                <option value="justify"></option>
                                            </select>
                                        </span>
                                        <div class="d-inline-block">
                                            <div class="btn-group" dropdown>
                                                <button dropdownToggle type="button" class="btn dropdown-toggle"
                                                        style="width: initial;">
                                                    Insert Field
                                                    <span class="caret"></span>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu" role="menu">
                                                    @for (field of emailTemplateBodyFields; track field) {
                                                        <li role="menuitem">
                                                            <a style="cursor: pointer;" class="dropdown-item"
                                                               (click)="insertFieldInBody(field)">{{ field.name }}</a>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </quill-editor>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (lastSent) {
            <div class="line lastSentInfo">
                <div
                    helpTooltip
                    position="top"
                    edgeBuffer="6%"
                    [contentComponent]="sentInfoTooltip">
                    Last sent by {{ lastSent }}
                </div>
            </div>
        }
        @if (appealRecommendationInfo) {
            <div class="line footer">
                @if (!editing) {
                    <button class="ace-btn has-icon btn-lg btn-primary"
                            style="height: 40px; margin-right: 6px;"
                            (click)="downloadEmail()">
                        <i class="fa fa-download"></i>
                    </button>
                }
                @if (!editing) {
                    <button class="ace-btn btn-primary"
                            style="margin-top: 10px; margin-right: 6px;"
                            (click)="sendEmail()">
                        Send Email
                    </button>
                }
                @if (editing) {
                    <button class="ace-btn btn-primary"
                            style="margin-top: 10px; margin-right: 6px;"
                            (click)="save()"
                            [disabled]="!canSave">
                        Save
                    </button>
                }
                @if (editing) {
                    <button class="ace-btn btn-primary btn-danger"
                            style="margin-top: 10px;"
                            (click)="cancel()">
                        Cancel
                    </button>
                }
            </div>
        }
    </div>
</ws-modal-wrapper>

<ng-template #visibilityTooltip>
    @if (selectedTemplate) {
        <div class="ws-flex-container-vertical">
            @if (selectedTemplate.description) {
                <div class="ws-flex-container-vertical mb-2">
                    <strong>Description:</strong>
                    <div>
                        {{ selectedTemplate.description }}
                    </div>
                </div>
            }
            @if (selectedTemplate.visibilityItem) {
                <div class="ws-flex-container-vertical mb-2">
                    <strong>Visibility:</strong>
                    <div>
                        <span style="font-style:italic">{{ selectedTemplate.visibilityItem.name }}</span>
                        {{ selectedTemplate.visibilityItem.description }}
                    </div>
                </div>
            }
            @if (selectedTemplate.changedByName) {
                <div class="ws-flex-container-vertical mb-2">
                    <strong>Updated By:</strong>
                    <div>
                        {{ selectedTemplate.changedByName }}
                    </div>
                </div>
            }
        </div>
    }
</ng-template>
